import React from 'react';
import { Tag } from '../../../../components/tag';
import { Event } from '../../../../stores/events';
import { EventStatusTag, getEventStatus } from '../../../../utils/event-status';
import style from './styles.module.scss';

const EventStatusDisplay: React.FC<{ record: Event }> = React.memo(
    ({ record }) => {
        const eventStatus = getEventStatus(
            new Date(record.startDate.toDate()),
            new Date(record.endDate.toDate())
        );

        return (
            <div className={style.status_container}>
                <div className={style.status_tags}>
                    {record.isActive ? (
                        <Tag variant="success">Active</Tag>
                    ) : (
                        <Tag variant="error">Inactive</Tag>
                    )}
                    {eventStatus && <EventStatusTag status={eventStatus} />}
                </div>
            </div>
        );
    }
);
EventStatusDisplay.displayName = 'EventStatusDisplay';

export default EventStatusDisplay;
